import Swal from "sweetalert2";

export const sweetAlertError = (errors) => {
  if (errors) {
    let title =
      errors.length > 0 ? errors.join(", ") : "Ocorreu um erro inesperado";

    Swal.fire({
      position: "center",
      icon: "error",
      title: title,
      showConfirmButton: false,
    });
  }
};

export const sweetAlertSuccess = (title, timer) => {
  return Swal.fire({
    position: "center",
    icon: "success",
    title: title,
    showConfirmButton: false,
    timer: timer,
  });
};

export default { sweetAlertError, sweetAlertSuccess };
